<generic-page
[title]="!displayOnModal || _monthlyID ? ('Evento' + ((_monthlyID) ? ' #' + _monthlyID  +  ' - '+ _appService.CoreCommonLiterals.Edit : ' - '+ _appService.CoreCommonLiterals.Add)) : ''"
[subTitle]="(incidentID && _dateCreated) ? 'Identificador Global #' + incidentID +' - '+ _dateCreated : incidentID ? 'Identificador Global #' + incidentID : ''"
[errorMessage]="_errorBackEnd"
[submitButtonText]="!displayOnModal ? _appService.CoreCommonLiterals.ButtonSave:''"
[enabledDropdownsubmitButton]="true"
[menuButtonList]="menuButtonList"
(onSubmit)="onConfirmSave()"
[submitButtonDisabled]="_formStatus === 1"
(onCancel)="!displayOnModal ? cancelForm() : null"
(click)="errorMess = ''"
[cancelButtonText]="!displayOnModal ? _appService.CoreCommonLiterals.ButtonCancel : ''"
[goBackOnCancel]="false"
[isGeneric]="false"
[customButton4Disabled]="_formStatus === 1"
[customButton4TypeDelete]="false"
(onCustomButton5)="onSave(formElement, $event)"
[customButton3Disabled]="(_formStatus === 1)"
[customButton3TypeDelete]="false">
<agm-map #agmMap *ngIf="displayOnModal"></agm-map>
  <form #formElement="ngForm">
    <div [ngClass]="{'disabled': _formStatus === 1 }">
      <div class="container p-0 m-0">
        <section class="w-100 left-side"> 
          <div class="card p-3">
            <p><strong>Datos de localización</strong></p>
            <div class="form-container mb-3">
              <div class="form-group input-group" [ngStyle]="{'min-width': displayOnModal ? '400px': '200px'}">
                <label for="address" class="w-100">Ubicación</label>
                <div class="pl-0 pr-1" [ngClass]="{'col-10': displayOnModal, 'col-12': !displayOnModal}" >
                  <input #search
                  class="form-control"
                  customFocus
                  name="address"
                  id="address"
                  (keydown.enter)="$event.preventDefault()"
                  (focus)="autocompleteFocus($event)"
                  (keyup)="isCoordinates(searchControl)"
                  placeholder="Buscar dirección"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="off"
                  [disabled]="incidentID || (incidentData.Incident?.DateTimeClosed?.Date?.Day)"
                  type="text"
                  [(ngModel)]="searchControl"
                  cnm-clear-input
                  [clearVisible]='!incidentID ? true: false'
                  (onClear)="onClickclearText()">
                </div>
                <button id="btn-map" *ngIf="displayOnModal"
                  type="button" 
                  class="btn btn-primary col-2 d-flex align-items-center justify-content-center align-bottom input-group-append" 
                  [tooltip]="'Visualizar y establecer ubicación en el mapa'"
                  (click)="openLocationMap()"
                  ><i class="fa-solid fa-map"></i>
                </button>
              </div>
              <app-incident-location-ref
              [(ngModel)]="incidentData.Incident"
              name="jsonData"
              [incidentID]="incidentID"
              [vialAxesFullList]="_vialAxesFullList"
              [kilometerPoint]="incidentData.Incident.KilometerPoint"
              [roadwayFullList]="_roadwayFullList"
              [trafficDirectionsFullList]="_trafficDirectionsFullList"
              [sectorFullList]="_sectorFullList"
              [subSectorFullList]="_subSectorFullList"
              [displayOnModal]="displayOnModal"
              (onReferencePoints)="onSetCoordinates($event)"
            ></app-incident-location-ref>
            </div>
          </div>
          <div class="mt-4">
            <app-incident-general-info
            [(ngModel)]="incidentData.Incident"
            name="jsonData"
            [incidentID]="incidentID"
            [displayTitle]="true"
            [communicationID]="communicationIDs?.length ? communicationIDs[0] : incidentData?.Incident?.CommunicationID"
            [incidentTypeFullList]="_incidentTypeFullList"
            [incidentSubTypeFullList]="_incidentSubTypeFullList"
            [incidentCategoryColorList]="incidentCategoryColorList"
            [incidentOriginFullList]="_incidentOriginFullList"
            (onChangeCategory)="onChangeCategory()"
            ></app-incident-general-info>
          </div>
          <div class="card p-3 my-4">
            <p><strong>Detalle, Observaciones y Daños</strong></p>
            <div class="form-container mb-3">
              <div class="form-group" style="min-width: 100%;">
                <label for="description">Detalles</label>
                <textarea
                  type="text"
                  maxlength="500"
                  name="description"
                  rows="3"
                  [disabled]="(incidentData.Incident?.DateTimeClosed?.Date?.Day)"
                  (click)="_errorBackEnd = ''"
                  [(ngModel)]="incidentData.Incident.Description"
                  class="form-control"
                  id="description"
                  [placeholder]="'Detalles'"
                ></textarea>
              </div>
              <div class="form-group" style="min-width: 100%;">
                <label for="observations">Observaciones</label>
                <textarea
                  type="text"
                  maxlength="500"
                  rows="3"
                  name="observations"
                  [disabled]="(incidentData.Incident?.DateTimeClosed?.Date?.Day)"
                  (click)="_errorBackEnd = ''"
                  (change)="setObservations()"
                  [(ngModel)]="_observations"
                  class="form-control"
                  id="observations"
                  [placeholder]="'Observaciones'"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <app-accordion class="w-100 form-container">
              <div class="table-container">
                <app-panel [title]="'Resumen Lesionados'" [titleFirts]="true" id="summary" [opened]="true">
                  <app-table [data]="_summaryTable"></app-table>
                </app-panel>
              </div>
            </app-accordion>
            <section>
              <app-incident-tables
              #attachmentTable
              [displayOnModal]="displayOnModal"
              [incidentData]="incidentData"
              [vialAxes]="incidentData?.Incident?.VialAxisID"
              [incidentID]="incidentID"
              [incidentClose]="(incidentData?.Incident?.Date?.Day)"
              [displayOnlyFileEvidence]="true">
              </app-incident-tables>
            </section>
          </div>
        </section>
        <section class="w-100 right-side">
          <app-incident-tables
          #tablesForm
          [displayOnModal]="displayOnModal"
          [incidentData]="incidentData"
          [incidentID]="incidentID"
          [vialAxes]="incidentData?.Incident?.VialAxisID"
          [incidentClose]="(incidentData.Incident?.DateTimeClosed?.Date?.Day)"
          [loadAssistances]="loadAssistances"
          [loadDataLanes]="loadDataLanes"
          [loadDataVehicles]="loadDataVehicles"
          [loadDataPersons]="loadDataPersons"
          [loadAddVehicles]="loadAddVehicles"
          [loadAddPersons]="loadAddPersons"
          [vehicleDataFullList]="vehicleDataFullList"
          [personDataFullList]="personDataFullList"
          (updateSummary)="setInjurySummary($event)">
        </app-incident-tables>
          <app-accordion class="w-100 form-container">
            <div class="table-container w-100">
              <app-panel [title]="'Grupos de notificaciones'" [titleFirts]="true" id="groups" [opened]="true">
                <div class="form-group row mb-2">
                  <div class="col-9 pr-1">
                    <label for="notificationGroups">Grupo
                      <span class="ml-1 text-truncate" style="color: var(--primary);" tooltip="Solo se permitiran agregar grupos en el proceso de creación de eventos"><i class="fa fa-question-circle"></i></span>
                    </label>
                    <div class="form-group" >
                      <custom-select
                        [filterEnabled]="true"
                        [bordered]="true"
                        [disabled]="(incidentData.Incident?.DateTimeClosed?.Date?.Day || incidentID)"
                        name="notificationGroups"
                        id="notificationGroups"
                        (click)="_errorBackEnd = ''"
                        [(ngModel)]="_selectedGroup"
                        [(sourceList)]="_optionsGroup">
                      </custom-select>
                    </div>
                  </div>
                  <div class="col-3 pl-1 d-flex align-items-center mt-4">
                    <button id="add-group-btn"  type="button" class="btn btn-primary w-100 text-truncate"
                    [disabled]="!_selectedGroup?.value || incidentData.Incident?.DateTimeClosed?.Date?.Day || incidentID" (click)="addNotificationGroup(_selectedGroup)"
                    [tooltip]="_appService?.CoreCommonLiterals?.Add">
                      <i class="fa fa-plus" aria-hidden="true"></i>{{_appService?.CoreCommonLiterals?.Add}}
                    </button>
                  </div>
                </div>
                <app-table
                  [data]="_notificationGroupTable"
                  [deletePermissionRoute]="true"
                  [editBtnRoute]="incidentID || (incidentData.Incident?.DateTimeClosed?.Date?.Day) ? false : true"
                  [deleteBtnRoute]="incidentID || (incidentData.Incident?.DateTimeClosed?.Date?.Day) ? false : true"
                  [customBtnRoute]="incidentID ? true : false"
                  [customBtnIcon]="incidentID ? 'fa-up-right-from-square' : ''"
                  [customBtnTooltip]="incidentID ? 'Ver grupo' : ''"
                  [customIconSize]="'fa-3x'"
                  [enablePagination]="true"
                  [rowsPerPage]="3"
                  (onEdit)="openEditModal($event, 'group', 'Grupo')"
                  (onRemove)="openRemoveModal($event, 'group')"
                  (onCustomAction)="exitEditing(25, $event)"
                ></app-table>
                <hr class="mb-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1); margin: auto;" [ngClass]="{'d-none': !_notificationGroupTable?.Elements?.length}">
              </app-panel>
            </div>
          </app-accordion>
        </section>
      </div>
    </div>
  </form>
  <div class="text-center my-3 not-found-data" *ngIf="_formStatus === 1">
    <i class="fas fa-circle-notch fa-spin fa-3x"></i>
  </div>
</generic-page>

<modal #mapDetails
  id="map-details"
  modalClass="modal-lg"
  [submitButtonText]="!incidentID ? _appService?.CoreCommonLiterals?.ButtonSave : ''"
  (onSubmit)="!incidentID ? onSaveLocation() : null"
  [(errorMessage)]="_errorLocationMessage"
  [closeButtonText]="_appService?.CoreCommonLiterals?.ButtonClose"  
  >
  <modal-header>Ubicación</modal-header>
  <modal-content>
    <agm-map #agmMap id="mapDetails" [fitBounds]="bounds" [maxZoom]="commonMapService.MaxZoom" [styles]="commonMapService.StylesIncidents"
    (mapReady)="onMapReady($event)" [latitude]="_latitudeCenter" [longitude]="_longitudeCenter" [zoom]="_zoom" (mapClick)="!incidentID ? mapClicked($event) : null">
      <agm-map-type-control></agm-map-type-control>
      <ng-container *ngIf="mapReady">
        <agm-polygon [clickable]="false" *ngFor="let pm of _pathsMaintenanceContractors" [paths]="pm.paths" [fillColor]="pm.fillColor"
        [fillOpacity]="pm.fillOpacity" [strokeColor]="pm.borderColor" [strokeOpacity]="pm.borderOpacity" [strokeWeight]="pm.borderWidth">
      </agm-polygon>
      <agm-polygon [clickable]="false" *ngFor="let pm of _pathsUtilityCompanies" [paths]="pm.paths" [fillColor]="pm.fillColor"
        [fillOpacity]="pm.fillOpacity" [strokeColor]="pm.borderColor" [strokeOpacity]="pm.borderOpacity" [strokeWeight]="pm.borderWidth">
      </agm-polygon>
      </ng-container>
    </agm-map>
  </modal-content>
</modal>

<modal #confirmExitRoute
  id="exit-route"
  modalClass="modal-lg"
  [(errorMessage)]="_errorMessage"
  [submitButtonText]="_appService?.CoreCommonLiterals?.ButtonSave"
  (onSubmit)="_confirmChangeTab ? onConfirmChangeTab(true) : onConfirmExitRoute(true, _confirmSaveChanges)"
  [closeButtonText]="_appService?.CoreCommonLiterals?.ButtonCancel"
  (onClose)="_confirmSaveChanges = false; _confirmChangeTab = 0"
  [otherButtonText]="!_confirmSaveChanges ? _appService?.CoreCommonLiterals?.Discard : null" (onAction)="_confirmChangeTab ? onConfirmChangeTab(false) : onConfirmExitRoute(false, _confirmSaveChanges)"
>
  <modal-header>{{_appService?.CoreCommonLiterals?.ConfirmSaveChanges}}</modal-header>
  <modal-content>
    <p *ngIf="!_confirmSaveChanges">{{_appService?.CoreCommonLiterals?.ConfirmSaveChangesBeforeLeaving}}</p>
    <p *ngIf="_confirmSaveChanges">¿Está seguro de que desea guardar los cambios?</p>
  </modal-content>
</modal>

<modal #editElementModal
  id="edit-element"
  modalClass="modal-lg"
  [(errorMessage)]="_errorMessage"
  [submitButtonText]="_appService?.CoreCommonLiterals?.ButtonSave"
  (onSubmit)="onConfirmEdit()"
  [closeButtonText]="_appService?.CoreCommonLiterals?.ButtonCancel"
>
  <modal-header>{{_appService?.CoreCommonLiterals?.Edit }} {{_editTitle}}</modal-header>
  <modal-content>
    <form #formElementModal="ngForm">
      <div class="row" *ngIf="_editType == 'group'">
        <div class="col-12">
          <app-incident-contact-groups [_optionsContacts]="_optionsContacts" [contactsFullList]="_contactsFullList" name="groupMembers" id="groupMembers" [(ngModel)]="groupsMemberList"></app-incident-contact-groups>
        </div>
      </div>
    </form>
  </modal-content>
</modal>

<modal-confirm #confirmRemove
id="confirm-remove-element"
[title]="_appService?.CoreCommonLiterals?.Delete"
[content]="_appService?.CoreCommonLiterals?.SureYouWantToContinue"
[submitButtonText]="_appService?.CoreCommonLiterals?.ButtonConfirm"
(submit)="remove()"
[closeButtonText]="_appService?.CoreCommonLiterals?.ButtonCancel">
</modal-confirm>
